{
    "rapormusteri": {
        "Baslik": "Customer Report",
        "Musteri": "Customer",
        "Referans": "Reference",
        "Kullanici": "User",
        "Cep": "Phone",
        "Cep2": "Phone 2",
        "Randevu": "Appointment",
        "SatisOnayli": "Approved Sale",
        "SatisOnaysiz": "Unapproved Sale",
        "SatisIptal": "Cancelled Sale",
        "SatisCayma": "Withdrawn Sale",
        "Arama": "Search",
        "Ara": "Search",
        "Kapat": "Close",
        "Temizle": "Clear",
        "BaslangicTarihi": "Member Since",
        "BitisTarihi": "Member Until",
        "Islemler": "Actions",
        "Duzenle": "Edit",
        "Sil": "Delete",
        "Ad": "First Name",
        "Soyad": "Last Name",
        "Cinsiyet": "Gender",
        "KimlikNo": "ID Number",
        "Email": "E-Mail",
        "Email2": "E-Mail 2",
        "Adres": "Address",
        "Aciklama": "Description",
        "Guncelle": "Update",
        "EminMisiniz": "Are you sure?",
        "GeriAlamazsiniz": "You cannot undo this action!",
        "EvetSil": "Yes, delete!",
        "Iptal": "Cancel",
        "ExcelAktar": "Export to Excel",
        "MusteriDetay": "Customer Detail",
        "Bilgisi": "Information",
        "Aktarma": "Transfer",
        "GeciciYetki": "Temporary Authority",
        "Durum": "Status",
        "Kilit": "Lock",
        "Meslek": "Profession",
        "DogumTarihi": "Date of Birth",
        "HedefKullanici": "Target User",
        "Aktar": "Transfer",
        "YetkiVerilecekKullanici": "Target User",
        "YetkiVer": "Give Authority",
        "VerilenYetkiler": "Given Authorities",
        "KayitBulunamadi": "No records found.",
        "Il": "City",
        "Ilce": "District",
        "Olusturma": "Creation",
        "SonGuncelleme": "Last Update",
        "TasimaAciklama": "All records of the selected customer will be transferred to the target customer and the current customer will be deleted.",
        "HedefMusteri": "Target Customer",
        "Tasi": "Move",
        "MevcutMusteriKodu": "Current Customer Code",
        "Onsekizalti": "Under 18",
        "SigortaEttiren": "Policyholder"
    }
}
